/* eslint-disable camelcase */
/* eslint-disable default-param-last */
/* eslint-disable no-console */
import dayjs from 'dayjs'
import { ANALYTICS_CONFIG, ANALYTICS_EVENT_TYPES } from './constants'

export const NA = 'NA'

export const setPageAnalytics = (
  location,
  type,
  province,
  language,
  tagManagerInfo = {},
  event_type,
  event_click,
  target_link
) => {
  if (typeof window !== 'undefined' && tagManagerInfo) {
    const {
      plan_name,
      plan_cost,
      customer_ban,
      customer_quote_id,
      dealer_info,
      uuid,
      journey_type,
      click_text,
      city,
      phone_number_province,
      field_warning,
      error_response_code,
      automatic_top_up,
      promoCodeDescription,
      eventCategory,
      consentObject,
      guestFlow
    } = tagManagerInfo

    // 🚩 define ignored fields when consentObject exists
    const IGNORED_IF_CONSENT = [
      "plan_name",
      "plan_cost",
      "journey_type",
      "promoCodeDescription",
      "phone_number_province",
      "field_warning",
      "error_code",
      "automatic_top_up",
      "eventCategory"
    ]

    // Build base page object
    let page = {
      name: formatPageName(location),
      customer_ban,
      type,
      category: eventCategory || 'prepaid',
      categorysub1: formatCategorySub(location),
      province,
      language,
      section: ANALYTICS_CONFIG.appName,
      plan_name,
      plan_cost,
      city: city || NA,
      uuid,
      date: dayjs().format('YYYY/MM/DD'),
      time: dayjs().format('hh:mm:ss'),
      journey_type,
      event_type: event_type || 'NA',
      target_link: target_link || 'NA',
      promoCodeDescription: promoCodeDescription || 'NA',
      click_text: click_text || 'NA',
      phone_number_province: phone_number_province || NA,
      field_warning: field_warning || 'NA',
      error_code: error_response_code || 'NA',
      automatic_top_up: automatic_top_up || 'NA'
    }

    // 🚩 If consentObject exists → strip ignored fields + merge consent details
    if (consentObject) {
      page = Object.fromEntries(
        Object.entries(page).filter(([key]) => !IGNORED_IF_CONSENT.includes(key))
      )
      page = {
        ...page,
        ...consentObject // spread consent fields directly into page
      }
    }

    const dataLayerInfo = {
      event: event_click || ANALYTICS_EVENT_TYPES.PAGE_VIEW,
      xdm: {
        web: {
          webPageDetails: {
            pageViews: { value: 1 },
            page,
            user: {
              customer_type: getCustomerType(location),
              customer_ban: customer_ban || 'NA',
              customer_quote_id: customer_quote_id || 'NA',
              channel_org_code:
                getCustomerType(location) === 'dealer' ? dealer_info?.channelOrgCode : 'NA',
              sales_rep_id: getCustomerType(location) === 'dealer' ? dealer_info?.salesRepId : 'NA',
              channel_outlet_id:
                getCustomerType(location) === 'dealer' ? dealer_info?.outletId : 'NA',
              current_outlet_province: dealer_info?.outletProvince || 'NA',
              // Whether this activation is using an auto-generated throw-away
              // address rather than the customer's own. Dealer-only: the guest
              // option is never offered on consumer, so the attribute is omitted
              // there entirely rather than reported as an always-false (the sibling
              // dealer fields above use 'NA' for that, but a boolean has no such
              // spelling — a literal `false` would read as a real consumer
              // measurement). Lives on `user` rather than `page` because it
              // describes who is activating, and because the consent-event
              // filtering only strips fields from `page`.
              ...(getCustomerType(location) === 'dealer' ? { guestFlow: guestFlow === true } : {})
            }
          }
        }
      }
    }
    return dataLayerInfo
  }
}


// helpers
/**
 * Formats the page name for use in analytics using location object.
 *
 * @param {object} location - location object used to format page name
 * @returns {string} - the formatted page name
 */
function formatPageName(location) {
  // /en/on/koodo/dealer/activation/transaction-summary > /prepaid/dealer/activation/transaction-summary
  const { pathname = '' } = location
  const pageName = pathname.split('/').splice(5).join('/')
  return `prepaid/${pageName}`
}

function formatCategorySub(location) {
  const { pathname = '' } = location
  return pathname.substring(pathname.lastIndexOf('/') + 1)
}

function getCustomerType(location) {
  const { pathname = '' } = location
  const type = pathname.split('/')[5] || null
  return type === 'dealer' ? 'dealer' : 'consumer'
}
